import {
  deleteDoc, doc, getFirestore, updateDoc,
} from 'firebase/firestore';
import { getStorage, ref, uploadBytes } from 'firebase/storage';

export type PostDraft = {
  title: string;
  description: string;
  tags: string[];
  staffId: string;
};

// カード「⋯」メニューと編集パネルの両方から呼ばれる、書き込みの唯一の窓口。

export async function saveDraft(id: string, draft: PostDraft, newImageFile: File | null): Promise<void> {
  if (newImageFile) {
    const storage = getStorage();
    await uploadBytes(ref(storage, `image/${id}`), newImageFile);
  }

  const db = getFirestore();
  await updateDoc(doc(db, 'posts', id), {
    post_title: draft.title,
    post_description: draft.description,
    post_tags: draft.tags,
    post_staff_id: draft.staffId,
    post_updated_at: new Date(),
  });
}

// 既存の 2.edit/index.tsx の deletes() と同一の挙動(Storageのクリーンアップは行わない、既存仕様のまま)。
// いいねしていたユーザーのuser_likesからの削除は、Cloud Functions
// cleanupUserLikesOnPostDelete（posts/{postId}のonDelete trigger、
// functions/postCleanup.js）がAdmin SDK経由で行う。Firestore Rulesの
// users本体を本人限定にしたため、client SDKからの直接横断updateは廃止した。
export async function hardDelete(id: string): Promise<void> {
  const db = getFirestore();

  await deleteDoc(doc(db, 'posts', id));
}
